import { Button, Col, Form, Input, Popconfirm, Row, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
export const RecipePhenoTypes = () => {

    const onChange = (checked, data) => {
        // console.log(`switch to ${checked}`);
        // console.log(data.id);
    };

    const columns = [
        {
            title: 'Pheno types',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch onChange={(e) => onChange(text, data)} />
                {/* <Switch checked={text}  onChange={(e) => onChange(text, data)} /> */}
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Vata',
            status: true
        },
        {
            id: '2',
            name: 'Pitta',
            status: false
        },
        {
            id: '3',
            name: 'Kapha',
            status: true
        },
    ];

    const [form] = Form.useForm();

    const onFinish = (values) => {
        // console.log(values);
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="RecipePhenoTypes">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addRecipePhenoTypesForm"
                        className="addRecipePhenoTypes"
                        form={form}
                    // onFinish={onFinish}
                    >
                        <Row className="addRecipePhenoTypesForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="recipe_pheno_types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Recipe Pheno Types!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Recipe Pheno Types" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />} >
                                    ADD
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                </Col>
                <Col xl={10} className="text-end align-self-center">
                    <h6>Total Recipe Pheno Types: 3 </h6>
                </Col>
                {/* <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Category"
                        // onChange={(e) => { (e.target.value); setCategoryData(e.target.value) }}
                        className="p-2" />
                </Col> */}
            </Row>
            <Row>
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    // pagination={false}
                    scroll={{ x: "max-content" }}
                    className="w-100"
                />
            </Row>
        </div>
    )
}
